import type { GatsbyBrowser } from 'gatsby';
import { PageWrapper, SiteWrapper } from 'components';
import 'i18n';
import 'react-medium-image-zoom/dist/styles.css';

export const wrapRootElement: GatsbyBrowser['wrapRootElement'] = ({ element }) => <SiteWrapper>{element}</SiteWrapper>;

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props: { location } }) => (
  <PageWrapper location={location}>{element}</PageWrapper>
);
